import React, { ReactNode, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Box, ButtonBase, Grid } from '@material-ui/core';

import { ReactComponent as LeftArrow } from '../../assets/img/icon/ArrowLeft.svg';
import { useNavigationContext } from '../../context/Navigation/navigation.provider';
import { useAuthDataContext } from '../../context/auth/auth.provider';
import Navigation from '../../screens/PrivateLayout/Account/Navigation/Navigation.component';

interface SubHeaderProps {
  content: ReactNode;
  actions?: ReactNode;
  fullActions?: boolean;
  goBack?: () => void;
  shouldGoBack?: boolean;
}

const SubHeader: React.FC<SubHeaderProps> = ({
  content,
  actions,
  fullActions,
  goBack,
  shouldGoBack = true,
}) => {
  // const { className } = props;
  const history = useHistory();
  const { navigationHistory, popNavigation, lastPath, isInModuleRoot } =
    useNavigationContext();
  const [locationKeys, setLocationKeys] = React.useState([]);
  const { embed } = useAuthDataContext();

  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  // COMPONENTE CON FLECHA NAVEGACION GO BACK

  // UTILIZADO POR...........................
  // - MIS POLIZAS
  // - MIS PAGOS
  // - INSPECCIONES
  // - CUENTA
  // - CANCELAR POLIZA (flecha inferior)
  // - NOTIFICACIONES
  // - PAGOS
  // - TARJETA DE CIRCULACION

  useEffect(() => {
    // TODO: quitar los navigation y poner history.push
    return history.listen((location) => {
      if (history.action === 'PUSH') {
        setLocationKeys([location.key]);
      }

      if (history.action === 'POP') {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);

          // Handle forward event
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);

          // Handle back event
          popNavigation(location, location.pathname);
        }
      }
    });
  }, [history, locationKeys, popNavigation]);

  return (
    <>
      <Grid container justify="center"></Grid>
      <Box bgcolor="#FAFAFA" display="flex" alignItems="center">
        <Grid container justify="center">
          <Grid item xs={11}>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid
                item
                xs={actions ? (fullActions ? 10 : 8) : 10}
                sm={actions ? 8 : 12}
                style={{ position: 'relative' }}
              >
                {shouldGoBack && (
                  <Box position="absolute" top={'40%'} left={'0%'}>
                    <ButtonBase>
                      <LeftArrow
                        onClick={() => {
                          const currentPath = history.location.pathname;

                          if (isInModuleRoot(currentPath)) {
                            embed
                              ? window.parent.postMessage(
                                  {
                                    return: `${
                                      currentPath.includes('documentation')
                                        ? 'policies'
                                        : 'overview'
                                    }`,
                                  },
                                  '*'
                                )
                              : redirectHome();
                          } else {
                            currentPath.includes('documentation')
                              ? currentPath.includes('/documentation/document/')
                                ? history.goBack()
                                : window.parent.postMessage(
                                    { return: 'policies' },
                                    '*'
                                  )
                              : history.goBack();
                          }
                        }}
                      />
                    </ButtonBase>
                  </Box>
                )}
                <Box my={4} style={{ marginLeft: shouldGoBack ? '40px' : '0' }}>
                  {content}
                </Box>
              </Grid>

              {actions ? (
                <Grid item xs={fullActions ? 10 : 4} sm={4}>
                  <Grid
                    container
                    justify={fullActions ? 'center' : 'flex-end'}
                    alignItems="center"
                  >
                    <Grid item xs={12}>
                      {actions}
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default SubHeader;
